<template>
    <div class="mt-2">
        <p class="text-sm text-gray-500">
            <slot />
        </p>
    </div>
</template>
